import { z } from 'zod';
import type { SharedCustomField } from '@/types/serializers';

export const candidatesInterviewLogsSchema = z.object({
  interviewedAt: z.date(),
  organizationUserId: z.string().min(1, '面談者の選択は必須です'),
  // 未指定（undefined）入力を空オブジェクトへ正規化する。共有スキーマとして
  // reset/parse で再利用された際にトップレベル必須エラーへ退行しないための後方互換。
  customData: z.record(z.string(), z.string().optional()).default({}),
});

export type CandidatesInterviewLogsSchema = z.infer<typeof candidatesInterviewLogsSchema>;
// useForm の入力型（customData は `.default({})` により入力時 optional）。
// zodResolver v5 は入力/出力型を分離するため useForm<Input, ctx, Output> で使う。
export type CandidatesInterviewLogsInput = z.input<typeof candidatesInterviewLogsSchema>;

// カスタムフィールドに基づいてスキーマを動的に生成
export function createCandidatesInterviewLogsSchema(customFields: Array<SharedCustomField>) {
  // 必須フィールドの情報を取得
  const requiredFields = customFields.filter((field) => field.is_required);

  return z.object({
    interviewedAt: z.date({
      error: '面談日時は必須です',
    }),
    organizationUserId: z.string().min(1, '面談者の選択は必須です'),
    customData: z
      .record(z.string(), z.string().optional())
      .superRefine((data, ctx) => {
        // 必須フィールドがすべて入力されているかチェック
        requiredFields.forEach((field) => {
          const fieldKey = String(field.id);
          const value = data[fieldKey];

          if (value === undefined || value === null || value === '') {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              path: [fieldKey],
              message: `${field.name}は必須です`,
            });
          }
        });
      })
      // 未指定（undefined）入力を空オブジェクトへ正規化する後方互換。
      .default({}),
  });
}
